
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  ><!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE --><path
    fill="currentColor"
    d="M18 12.998H6a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2"
  /></svg>
</template>

<script>
export default {
  name: 'IcRoundMinus'
}
</script>